// extracted by mini-css-extract-plugin
export default {"wrapper":"EditTip_wrapper__qpxKy"};